<section class="ambassador-hero">
    <div class="text">
        <h1 [style.viewTransitionName]="'title'">Be a Voice That Moves Others</h1>
        <p>
            It starts with one voice. One message. One moment that joins a growing chorus, sharing hope, connection, love, and
            understanding with every person touched by cancer. <br /><br />
            Being a WondrVoices Ambassador means letting your voice be that spark, the one that ripples outward, taking its own
            shape in your community. Where you share it, how you express it, and who it touches will be uniquely yours.

        </p>
        <a href="/get-involved#get-involved-form">
            <button class="button ambassador-btn">Become an Ambassador →</button>
        </a>
    </div>
    <div class="image">
        <img src="assets/img/get-involved/hero.webp" alt="Hero">
        <!-- <app-swiper [slides]="slides" /> -->
    </div>
</section>

<section class="ambassador-info">
    <div class="ambassador-section">
        <h2>What Ambassadors Do</h2>
        <p>
            When you become a WondrVoices Ambassador, you join a movement built on connection. Your role is simple: take one small
            action to spread kindness, and watch it grow. <br /> <br />
            You might:
        </p>
        <ul>
            <li><strong>Invite your local spots:</strong> cafés, libraries, galleries, to become WondrSpots</li>
            <li><strong>Host a card-making table,</strong> at a farmers market, art fair, or park bench</li>
            <li><strong>Write and decorate a card yourself,</strong> then encourage friends to do the same</li>
            <li><strong>Spread awareness</strong> on Instagram, TikTok, Facebook, or Nextdoor</li>
        </ul>
    </div>

    <div class="ambassador-section">
        <h2>Make Kindness Go Viral</h2>
        <p>
            Kindness has momentum.
            Researchers have found that a single good deed can ripple outward, touching people up to three degrees removed from the
            original act. <br /><br />
            That’s why your voice matters.<br />
            Each card, each conversation, each new WondrSpot you inspire becomes part of a growing chorus, carrying hope,
            connection, love, and understanding into communities you may never see.<br /><br />
            You don’t have to walk in someone’s shoes to care.<br />
            You just have to be willing to reach.<br /><br />
            <strong>Be the drop.</strong><br />
            The quiet spark that sets kindness in motion, until it ripples farther than you’ll ever know.
        </p>
    </div>
</section>

<section class="ambassador-form" id="get-involved-form">
    @if (!submitted()) {
        <h2>Ready to join?</h2>
        <h3>Whether you have five minutes or five hours, your effort matters.</h3>
    
        <form [formGroup]="form" (ngSubmit)="submit()" class="form" autocomplete="on">
            @for (f of fields; track f.key) {
                <div class="form-group">
                    <div class="input-wrapper">
                        <input
                        [id]="f.key"
                        [formControlName]="f.key"
                        [attr.name]="f.key"
                        [type]="f.type"
                        [attr.autocomplete]="f.autocomplete"
                        placeholder=" "/>
                        <label [for]="f.key" [class.focused]="form.get(f.key)?.value">{{ f.label }}</label>
                    </div>
                </div>
              }
    
            <div class="form-group checkbox">
                <input type="checkbox" formControlName="consent" id="consent" />
                <label for="consent">
                    I agree to let Wondrvoices use my submission in printed or digital form to bring hope to patients.
                    I understand that not all submissions may be printed or shared.
                </label>
            </div>
    
            <button class="button submit-btn primary" type="submit"
                [disabled]="(form.invalid && form.touched && form.dirty) || isLoading()">
                Sign Me Up
            </button>
        </form>
    } @else {
        <h2>Thank you for joining as a WondrVoices Ambassador!</h2>
        <p style="text-align: center;">
            Your voice is now part of a growing movement that spreads kindness and hope. We’ll be in touch soon with more details
            on how to get involved.
        </p>
    }
</section>